import { BuyGuideVendorRebateProgramRebates } from '../../../components/BuyGuide';

export function BuyGuideRebateProgramRebates() {
  return <BuyGuideVendorRebateProgramRebates />;
}
